<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="user.isSuperadmin || user.type !== 'student'")
            label.fields__label {{ $i18n.tc('fields.fields_school', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="schools",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                :loading="loadingSchools",
                @open="getSchools",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.school",
                :maxHeight="150"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
        .fields__element(v-if="user.type === 'admin' || user.isManagerOrSupport")
            label.fields__label {{ $i18n.t('fields.fields_teacher') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="teachers",
                :show-labels="false",
                label="fullName",
                track-by="id",
                :searchable="true",
                :loading="loadingTeachers",
                @open="getTeachers",
                :placeholder="teachersPlaceholder",
                v-model="form.teacher",
                :disabled="isTeacherDisabled",
                :maxHeight="150"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_teacherNotFound') }}
        .fields__element
            label.fields__label {{ $i18n.tc('fields.fields_grade', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="grades",
                :show-labels="false",
                label="name",
                track-by="id",
                :loading="loadingGrades",
                @open="getGrades",
                :placeholder="gradesPlaceholder",
                v-model="form.grade",
                :disabled="isGradeDisabled",
                :maxHeight="150"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
        .fields__element.fields__element--search-neighbour
            label.fields__label {{ $i18n.t('fields.fields_address') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="locations",
                :show-labels="false",
                :allow-empty="false",
                :placeholder="form.school ? '' : $i18n.t('fields.fields_chooseSchoolPlaceholder')",
                :custom-label="getFullAddress",
                v-model="form.location",
                :disabled="locations && locations.length === 0"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_addressNotFound') }}
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import searchFieldsMixin from '../../utils/searchFieldsMixin';
    import {mapState} from 'vuex';
    import _ from 'lodash'

    export default {
        mixins: [searchFieldsMixin],
        data() {
            return {
                schools: [],
                grades: [],
                teachers: [],
                locations: [],
                form: {
                    school: null,
                    teacher: null,
                    grade: null,
                    location: ''
                },
            }
        },
        watch: {
            user: {
                handler (user) {
                    if (user && user.school && (user.type === 'admin' || user.type === 'teacher')) {
                        this.$emit('search', {schoolsIds: user.schoolsIds});
                    }
                },
                immediate: true
            },
            'form.school' () {
                this.updateList()
            },
            'form.teacher'() {
                this.updateList()
            },
            'form.grade'() {
                this.updateList()
            },
            'form.location'() {
                this.updateList()
            },
        },
        methods: {
            getFullAddress(location) {
                return `${location.city}, ${location.address}`;
            },
            sendForm() {
                let params = {};
                ['school', 'grade', 'teacher', 'location'].forEach(item => {
                    if (this.form[item]) {
                        params[item + 'Id'] = this.form[item].id;
                    }
                });
                this.$emit('search', params);
            },
            resetResults() {
                this.$emit('search', {});
                if (this.user.isSuperadmin || this.user.type === 'admin') {
                    this.form.grade = null;
                    this.form.location = '';
                    this.form.teacher = null;
                    this.form.school = null;
                } else if (this.user.type === 'teacher') {
                    this.form.grade = null;
                    this.form.location = '';
                }
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/sass/fields/fields.scss";
</style>
